import { CommonFunctions } from "../static/common-functions";
import { GItem } from "./GItem";

export class GItemDC extends GItem {
    constructor(data: GItemDC = null) {
        super(data);
        if (data != null) {
            this.dc = data.dc;
        }
    }
    dc: any;
    getDCValue(key: string): any {
        let retVal: any = null;
        try {
            retVal = this.dc[key];
        }
        catch (err) {

        }
        return retVal;
    }
    getDCValueNumber(key: string): number {
        return CommonFunctions.getNumberValue(this.getDCValue(key));
    }
    getDCValueString(key: string): string {
        return CommonFunctions.getStringValueIfNull(this.getDCValue(key),"");
    }
}
